import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, Alert } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import api from '../api'; // Используем api вместо axios

const Login = ({ setRole }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post(`${config.apiBaseUrl}/auth/login`, { username, password });
            if (response.data.auth) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('userId', response.data.userId);
                setRole(response.data.role);
                navigate(response.data.role === 'admin' ? '/admin' : '/dashboard');
            }
        } catch (err) {
            if (err.response) {
                // Ошибка от сервера (например, 401 Unauthorized)
                setError('Неверное имя пользователя или пароль');
            } else if (err.request) {
                // Сервер не ответил
                setError('Сервер недоступен');
            } else {
                // Другие ошибки (например, ошибка в коде)
                setError('Произошла ошибка при попытке входа');
            }
        }
    };

    return (
        <Container maxWidth="sm">
            <Box mt={5} textAlign="center">
                <LockIcon fontSize="large" color="primary" />
                <Typography variant="h4" gutterBottom>
                    Вход в систему
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                <Box component="form" onSubmit={handleLogin} sx={{ mt: 2 }}>
                    <TextField
                        fullWidth
                        label="Имя пользователя"
                        variant="outlined"
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <TextField
                        fullWidth
                        label="Пароль"
                        type="password"
                        variant="outlined"
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Войти
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default Login;